import { Container, Typography, Box } from '@mui/material';

/**
 * OCI AI 테스트 - 모델 비교 페이지
 * 
 * @description 여러 AI 모델의 응답을 동시에 비교하는 페이지
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-20
 */
const OciAiTestComparePage = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box mb={3}>
        <Typography variant="h4" component="h1" gutterBottom>
          🔬 AI 모델 비교
        </Typography>
        <Typography variant="body1" color="text.secondary">
          여러 AI 모델에 동일한 질문을 하여 응답을 비교해보세요.
        </Typography>
      </Box>

      <Box 
        sx={{ 
          height: 400,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px dashed #ddd',
          borderRadius: 2,
          backgroundColor: '#f9f9f9'
        }}
      >
        <Typography variant="h6" color="text.secondary">
          🚧 모델 비교 기능 구현 예정
        </Typography>
      </Box>
    </Container>
  );
};

export default OciAiTestComparePage;